import React, { FunctionComponent } from 'react';
import { BrassLogo } from '../../components';

const LogoPlayground: FunctionComponent = () => <BrassLogo height={''} width={''} />;
export { LogoPlayground };
